/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengesListResponseChallengesInner
 */
export interface ChallengesListResponseChallengesInner {
    /**
     * 
     * @type {string}
     * @memberof ChallengesListResponseChallengesInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengesListResponseChallengesInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengesListResponseChallengesInner
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengesListResponseChallengesInner
     */
    end?: number;
}

/**
 * Check if a given object implements the ChallengesListResponseChallengesInner interface.
 */
export function instanceOfChallengesListResponseChallengesInner(value: object): value is ChallengesListResponseChallengesInner {
    return true;
}

export function ChallengesListResponseChallengesInnerFromJSON(json: any): ChallengesListResponseChallengesInner {
    return ChallengesListResponseChallengesInnerFromJSONTyped(json, false);
}

export function ChallengesListResponseChallengesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengesListResponseChallengesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
    };
}

export function ChallengesListResponseChallengesInnerToJSON(json: any): ChallengesListResponseChallengesInner {
    return ChallengesListResponseChallengesInnerToJSONTyped(json, false);
}

export function ChallengesListResponseChallengesInnerToJSONTyped(value?: ChallengesListResponseChallengesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'start': value['start'],
        'end': value['end'],
    };
}

